// ----------------------------------------------------------------------------
// Nombre del Programa : DetalleSolicitudComunicado
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el detalle de una solicitud de comunicado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './DetalleSolicitudComunicado.scss';
import 'react-status-alert/dist/status-alert.css';
import { Row, Col } from 'react-bootstrap';
import { BotonRegresar } from '../../../components/boton-regresar/BotonRegresar';
import { useParams } from 'react-router-dom';
import { NuevaSolicitud } from './NuevaSolicitud';
import { VistaSolicitud } from './VistaSolicitud';

export const DetalleSolicitudComunicado = () => {
  const params = useParams();
  let idSolicitud = params.id ?? '0';

  return (
    <>
      <Row className="pt-3">
        <BotonRegresar></BotonRegresar>
      </Row>
      <div className="m-5">
        {idSolicitud !== '0' ? (
          <VistaSolicitud idSolicitud={idSolicitud}></VistaSolicitud>
        ) : (
          <NuevaSolicitud></NuevaSolicitud>
        )}
      </div>
    </>
  );
};
